import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { grpc } from '@improbable-eng/grpc-web';

import {
  ContentInfoQuery,
} from '../content/common_pb';
import {
  ContentMetadata,
} from '../content/content_pb';

import {
  Content as __Content,
} from '../content/content_pb_service';

@Injectable({providedIn: 'root'})
export class Content {

  constructor(private _ngZone: NgZone) {
  }

  getContentMetadata(request: ContentInfoQuery): Promise<ContentMetadata>;
  getContentMetadata(request: ContentInfoQuery, metadata: grpc.Metadata): Promise<ContentMetadata>;
  getContentMetadata(request: ContentInfoQuery, callback: (err: any|null, response: ContentMetadata, metadata: grpc.Metadata) => void): void;
  getContentMetadata(request: ContentInfoQuery, metadata: grpc.Metadata, callback: (err: any|null, response: ContentMetadata, metadata: grpc.Metadata) => void): void;

  getContentMetadata(request: ContentInfoQuery, arg1?: grpc.Metadata|((err: any|null, response: ContentMetadata, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: ContentMetadata, metadata: grpc.Metadata) => void): Promise<ContentMetadata>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<ContentMetadata>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__Content.GetContentMetadata, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

}

